export const parseOAuthFragment = (hash: string): Record<string, string> =>
{
  const data: Record<string, string> = {};

  if (!hash || hash.indexOf('#') !== 0)
  {
    return data;
  }

  const queryString = hash.substr(1);
  const pairs = queryString.split('&');

  for (const pair of pairs)
  {
    const separatorIndex = pair.indexOf('=');
    let key: string, value: string;

    if (separatorIndex === -1)
    {
      key = decodeURIComponent(pair);
      value = '';
    }
    else
    {
      key = decodeURIComponent(pair.substr(0, separatorIndex));
      value = decodeURIComponent(pair.substr(separatorIndex + 1));
    }

    data[key] = value;
  }

  return data;
};

export const setupOAuthCallback = (callback: (data: Record<string, string>) => void) =>
{
  // Guardar callback en window para que authcomplete.html pueda accederlo
  (window as any).oauthCallback = callback;
};
